<script>
  import { duplicateIcon } from "../../../Utils/utilConstants.svelte";
  import { copyObjContent } from "../../../Utils/utilFunctions.svelte";
  import { CardLayout } from "../index.svelte";

  export let data = "";

  $: btnOptions = [
    {
      iconName: "copyIcon",
      iFont: duplicateIcon,
      hasTooltip: true,
      tooltip: "Copy content",
      iconFunction: () =>
        copyObjContent(_getDisplayDataText(data), "Exception Data Copied!"),
      isHidden: !data,
    },
  ];

  // HELPER FUNCTIONS
  const _getDisplayDataText = (text) => {
    return text
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;")
      .replace(/&#039;/g, "'");
  };
</script>

<CardLayout title="Exception Data" {btnOptions}>
  <div class="flex flex-col p-2 w-full gap-y-3">
    <div class="flex flex-row gap-x-2">
      {#if data}
        <pre
          class="ml-3 pr-3 whitespace-pre-wrap font-sans break-words">{_getDisplayDataText(
            data,
          )}</pre>
      {:else}
        <p>No exception data</p>
      {/if}
    </div>
  </div>
</CardLayout>
